import { createSelector } from 'reselect'

export const getCartHistoryInitiallyFetched = createSelector(
  (state) => state && state.cart && state.cart.history && state.cart.history.initiallyFetched,
  initiallyFetched => initiallyFetched
)
